export const TWILIO_TECH_CHECK_SMS = "twilio-tech-check-sms";
export const DOCUMENT_UPLOADER_REQUIREMENTS_INSTRUCTIONS =
  "document-uploader-requirements-instructions";
export const TECH_CHECK_SELECT_DEVICES = "tech-check-select-devices";
